import * as THREE from "three";
import { worldOnSphereFromNorm } from "../../../lib/equirectSphereNorm.ts";

/** Inner sphere radius in `createPatrolEquirectSphereMesh`. */
export const PATROL_EQUIRECT_SPHERE_RADIUS = 100;

const FOCUS_RING_VISIBLE_DOT = 0.04;

/**
 * Project equirect focus norm to CSS px inside `hostEl` (wankhede-360 immersive ring).
 */
export function projectPatrolFocusRingToHost(
  canvas,
  camera,
  hostEl,
  normX,
  normY,
) {
  if (!canvas || !camera || !hostEl) {
    return { visible: false };
  }

  const world = worldOnSphereFromNorm(
    normX,
    normY,
    PATROL_EQUIRECT_SPHERE_RADIUS,
  );
  const camForward = new THREE.Vector3();
  camera.getWorldDirection(camForward);
  const sphereDir = world.clone().normalize();
  if (sphereDir.dot(camForward) < FOCUS_RING_VISIBLE_DOT) {
    return { visible: false };
  }

  const projected = world.clone().project(camera);
  const canvasR = canvas.getBoundingClientRect();
  const hostR = hostEl.getBoundingClientRect();
  const xInCanvas = (projected.x * 0.5 + 0.5) * canvasR.width;
  const yInCanvas = (-projected.y * 0.5 + 0.5) * canvasR.height;

  return {
    visible: true,
    left: canvasR.left - hostR.left + xInCanvas,
    top: canvasR.top - hostR.top + yInCanvas,
    hostWidth: Math.max(hostR.width, 1),
    hostHeight: Math.max(hostR.height, 1),
  };
}

/** Project a world point on the patrol sphere to host-local CSS pixels. */
export function projectPatrolWorldToHostPx(canvas, camera, hostEl, worldVec) {
  if (!canvas || !camera || !hostEl || !worldVec) {
    return { visible: false };
  }
  const camForward = new THREE.Vector3();
  camera.getWorldDirection(camForward);
  const sphereDir = worldVec.clone().normalize();
  if (sphereDir.dot(camForward) < FOCUS_RING_VISIBLE_DOT) {
    return { visible: false };
  }
  const projected = worldVec.clone().project(camera);
  const canvasR = canvas.getBoundingClientRect();
  const hostR = hostEl.getBoundingClientRect();
  const xInCanvas = (projected.x * 0.5 + 0.5) * canvasR.width;
  const yInCanvas = (-projected.y * 0.5 + 0.5) * canvasR.height;
  return {
    visible: true,
    left: canvasR.left - hostR.left + xInCanvas,
    top: canvasR.top - hostR.top + yInCanvas,
    hostWidth: Math.max(hostR.width, 1),
    hostHeight: Math.max(hostR.height, 1),
  };
}
